import { Box, Typography } from '@mui/material';
import { ContentContainer as LayoutContentContainer, RootContainer } from '../layout/Containers';
import { fontWeight } from '@app/theme/typography';
import { HFlex, VFlex } from '../FlexContainers';
import { palette } from '../../theme/palette';
import { styled } from '@mui/system';

export const Root = styled(RootContainer, {
  shouldForwardProp: (prop) => prop !== 'navbarSpacerHeight' && prop !== 'useAutoHeight' && prop !== 'breakpoint',
})<{ navbarSpacerHeight?: number; useAutoHeight?: boolean; breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>`
  max-width: 100vw;
  padding-top: 63px;
  padding-bottom: 55px;
  height: ${({ navbarSpacerHeight = 0, useAutoHeight }) =>
    useAutoHeight ? 'auto' : `calc(100vh - ${navbarSpacerHeight}px)`};
  min-height: ${({ useAutoHeight }) => (useAutoHeight ? `unset` : 'fit-content')};
  ${({ theme, breakpoint = 'sm' }) => theme.breakpoints.down(breakpoint)} {
    padding-top: 20px;
  }
`;

export const ContentContainer = styled(LayoutContentContainer)``;

export const TitleContainer = styled(HFlex, {
  shouldForwardProp: (prop) => prop !== 'breakpoint',
})<{ breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>`
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
  ${({ theme, breakpoint = 'sm' }) => theme.breakpoints.down(breakpoint)} {
    margin-top: 0;
  }
`;

export const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'breakpoint',
})<{ breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>`
  color: ${palette.custom.darkGrey};
  font-size: 38px;
  font-weight: ${fontWeight.heavy};
  line-height: 38px;
  letter-spacing: 0.95px;
  text-transform: capitalize;
  ${({ theme, breakpoint = 'sm' }) => theme.breakpoints.down(breakpoint)} {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0px;
  }
`;

export const HeaderWrapper = styled(VFlex, {
  shouldForwardProp: (prop) => prop !== 'breakpoint',
})<{ breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>`
  margin-bottom: 15px;
  ${({ theme, breakpoint = 'sm' }) => theme.breakpoints.down(breakpoint)} {
    margin-bottom: 40px;
  }
`;

export const BackButtonWrapper = styled(HFlex, {
  shouldForwardProp: (prop) => prop !== 'breakpoint',
})<{ breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>`
  gap: 9px;
  align-items: center;
  margin-bottom: 12px;
  ${({ theme, breakpoint = 'sm' }) => theme.breakpoints.down(breakpoint)} {
    margin-bottom: 8px;
  }
`;

export const BackButton = styled(Box)`
  color: ${palette.custom.darkGrey};
  font-size: 14px;
  font-style: normal;
  font-weight: ${fontWeight.regular};
  line-height: 18px;
  letter-spacing: 0.35px;
`;

export const ContentWrapper = styled(Box)`
  flex-grow: 1;
`;
